export default __webpack_public_path__ + "static/media/p2-10.e87fe54c.png";